import React from 'react';
import { Instagram, Facebook, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';
import { brand } from '../../mock';
import Logo, { Wordmark } from './Logo';

const Footer = () => {
  return (
    <footer className="pt-20 pb-10 bg-[var(--brand-cream-2)] border-t border-[rgba(31,58,46,0.08)]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <Logo size={40} />
              <Wordmark />
            </div>
            <p className="mt-5 text-[var(--brand-mute)] max-w-md text-sm leading-relaxed">
              Elevate combines evidence-based medicine, personalised nutrition and lifestyle optimisation to help you achieve your best health. {brand.formerly}.
            </p>
            <div className="mt-6 flex items-center gap-2">
              {[Instagram, Facebook, Youtube].map((Ic, i) => (
                <a
                  key={i}
                  href="#"
                  className="h-10 w-10 rounded-full border border-[rgba(31,58,46,0.15)] grid place-items-center text-green hover:bg-[var(--brand-green)] hover:text-[var(--brand-cream)] transition-colors"
                  aria-label="Social"
                >
                  <Ic size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <FooterCol
              title="Explore"
              links={[
                ['Care Model', '/#pathways'],
                ['Programs', '/#programs'],
                ['Team', '/#team'],
                ['Approach', '/#journey'],
              ]}
            />
          </div>
          <div className="lg:col-span-2">
            <FooterCol
              title="Services"
              links={[
                ['Weight Loss', '/#services'],
                ['Functional Medicine', '/#services'],
                ['Hormone Therapy', '/#services'],
                ['IV Therapy', '/#services'],
              ]}
            />
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-[var(--brand-gold)] mb-3">Contact</div>
            <div className="space-y-2 text-sm text-[var(--brand-ink)]">
              <a href={`tel:${brand.phone.replace(/\s/g, '')}`} className="block hover:text-[var(--brand-gold)]">{brand.phone}</a>
              <a href={`mailto:${brand.email}`} className="block hover:text-[var(--brand-gold)] break-all">{brand.email}</a>
              <div className="text-[var(--brand-mute)]">{brand.address}</div>
              <Link to="/contact" className="inline-block mt-2 text-[var(--brand-green)] underline underline-offset-4 hover:text-[var(--brand-gold)]">
                Visit contact page →
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[rgba(31,58,46,0.1)] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[var(--brand-mute)]">
          <div>© {new Date().getFullYear()} Elevate Medical Clinics. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-green">Privacy</Link>
            <Link to="/terms" className="hover:text-green">Terms</Link>
            <Link to="/accessibility" className="hover:text-green">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <div className="text-xs uppercase tracking-[0.22em] text-[var(--brand-gold)] mb-3">{title}</div>
    <div className="flex flex-col gap-2 text-sm">
      {links.map(([l, h]) => (
        <a key={l} href={h} className="text-[var(--brand-ink)] hover:text-[var(--brand-green)]">{l}</a>
      ))}
    </div>
  </div>
);

export default Footer;
